<mat-expansion-panel>
<mat-expansion-panel-header>
    Filtra
</mat-expansion-panel-header>
<form [formGroup]="filtersForm" novalidate>
     <div class="u-flex-full">
        <mat-form-field class="u-full-width">
            <!-- <mat-icon matSuffix>search</mat-icon> -->
            <mat-label>Cerca Cliente</mat-label>
            <input matInput formControlName="filter">
        </mat-form-field>

        <div>
        <mat-form-field class="u-full-width">
            <mat-select formControlName="onlyCurrentTenant">
            <mat-option [value]="true">Filtra per P.V</mat-option>
            <mat-option [value]="false">Filtra per tutti</mat-option>
            </mat-select>
        </mat-form-field>
        </div>

    </div>
    <div class="u-flex-full" style="justify-content: flex-end;">
        <button mat-raised-button [disabled]="filtersForm.pristine"
          (click)="applyFilters()" color="primary">Filtra</button>
        <button mat-icon-button *ngIf="!filtersForm.pristine" (click)="resetFilters()" matTooltip="Reset">
          <mat-icon>replay</mat-icon>
        </button>
    </div>

</form>
</mat-expansion-panel>
